import { createApp, defineComponent, h } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css';


import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska"

import VueFeather from 'vue-feather';
import * as FeatherIcons from '@zhuowenli/vue-feather-icons';
import Ripple from 'vue-ripple-directive';
import Vue3Toastify,{  toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

import VueSelect from 'vue3-select'
import 'vue3-select/dist/vue3-select.css'



import '@/assets/scss/config/default/app.scss';
import "leaflet/dist/leaflet.css";
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'




// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { fas } from '@fortawesome/free-solid-svg-icons'

import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import JsonExcel from "vue-json-excel3";

/* add icons to the library */
library.add(fas,fab,far);


AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

const FeatherIcon = defineComponent({
    name: 'FeatherIcon',
    props: {
        icon: {
            type: String,
            required: true,
        },
        size: {
            type: [String, Number],
            default: undefined,
        },
    },
    setup(props, { attrs }) {
        return () => {
            const IconComponent = FeatherIcons[props.icon];
            if (!IconComponent) return null;
            return h(IconComponent, { ...attrs, size: props.size });
        };
    },
});

const BIconCompat = defineComponent({
    name: 'BIconCompat',
    props: {
        icon: {
            type: String,
            default: '',
        },
        fontScale: {
            type: [String, Number],
            default: 1,
        },
    },
    setup(props, { attrs }) {
        return () => {
            const parsedScale = Number(props.fontScale);
            const fontSize = Number.isFinite(parsedScale) ? `${parsedScale}em` : undefined;
            return h('i', {
                ...attrs,
                class: ['bi', props.icon ? `bi-${props.icon}` : '', attrs.class],
                style: [attrs.style, fontSize ? { fontSize } : {}],
                'aria-hidden': 'true',
            });
        };
    },
});



createApp(App)
    .use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVueNext)
    .use(VueSweetalert2)
    .component(VueFeather.type, VueFeather)
    .component('feather-icon', FeatherIcon)
    .component('b-icon', BIconCompat)
    .component('font-awesome-icon', FontAwesomeIcon)
    .component('VSelect', VueSelect)
    .component("downloadExcel", JsonExcel)
    .directive('ripple', Ripple)
    .directive("maska", vMaska)
    .use(i18n)
    .use(Vue3Toastify,toast)
    .use(vClickOutside).mount('#app');

   